(function () {
// Pull in any required Libraries.
// import "./lib/modernizr-dev" (Already loaded)
function $b2a8c2caad66ecf5$export$f838c8bfb28edc63() {
    // Declare variables
    var input, filter, divTable, divRow, tableData, i, txtValue;
    input = document.getElementById("state-search");
    filter = input.value.toUpperCase();
    divTable = document.getElementById("tally-list");
    divRow = divTable.getElementsByClassName("state-row");
    // Loop through all table rows, and hide those who don't match the search query
    for(i = 0; i < divRow.length; i++){
        tableData = divRow[i].getElementsByTagName("div")[0];
        if (tableData) {
            txtValue = tableData.textContent || tableData.innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) divRow[i].style.display = "";
            else divRow[i].style.display = "none";
        }
    }
}


function $7ea0b8b073c2add7$export$2e2bcd8739ae039() {
    // Get all elements with the class "column-end.--large"
    var divTable = document.getElementById("tally-list");
    if (divTable) {
        const elements = document.querySelectorAll(".column-end.--large");
        elements.forEach((element)=>{
            element.addEventListener("click", ()=>{
                element.classList.toggle("js-expanded"); // Toggle the "expanded" class on the clicked element
                // Unset the 'default' height explicitly for the box.
                element.style.height = "";
                element.css("min-height", "120px");
            });
        });
    }
}


function $a0b9ba5cc79899f3$export$2e2bcd8739ae039() {
    console.log("I am loading - Simple Modal.");
    // Get each modal and close button.
    const triggers = document.getElementsByClassName("modal-trigger");
    const triggerArray = Array.from(triggers).entries();
    const modals = document.getElementsByClassName("modal-item");
    const closeButtons = document.getElementsByClassName("modal-close");
    // Then use `for...of`-loop with the index of each item in `triggerArray` for
    // listening to a click event which toggles each modal to open and close.
    for (let [index, trigger] of triggerArray){
        const toggleModal = ()=>{
            /**
       * GeoLocation Trigger - Ensure 'Button' is visible.
       *
       * - If button not present (due to previous removal), re-add button.
       */ let modalTrigger = document.getElementById("modal-geotrigger");
            modalTrigger.style.display = "block";
            let locationPending = document.getElementById("geolocation-pending");
            locationPending.style.display = "none";
            // Using '0' instead of 'index' so the 'Open Modal' trigger works from every button.
            modals[0].classList.toggle("open-modal");
        };
        trigger.addEventListener("click", toggleModal);
        closeButtons[index].addEventListener("click", toggleModal);
    }
}


/**
 * Cancel Geolocation
 *
 * If 'Turn Off Location' is clicked, remove.
 */ function $46dfd3e75536697e$export$2e2bcd8739ae039() {
    // console.log('I am loading - geolocation.js - Cancelling');
    const locationCancelTriggers = document.getElementsByClassName("geolocation-cancel");
    const triggerArray = Array.from(locationCancelTriggers).entries();
    let jumpToBlock = document.getElementsByClassName("location__jump-to-container")[0]; // Only a single Jump-To box.
    for (let [index, trigger] of triggerArray){
        const cancelGeoLocation = ()=>{
            // Clear Banner Content.
            geoLocationElement = document.getElementById("geolocation-found");
            geoLocationElement.innerHTML = "";
            // Hide 'location__banner--located'.
            defaultLocationBanner = document.getElementsByClassName("location__banner--located");
            defaultLocationBanner[0].style.display = "none";
            // Show 'location__banner--default' and the 'Jump To' banner.
            defaultLocationBanner = document.getElementsByClassName("location__banner--default");
            defaultLocationBanner[0].style.display = "flex";
            const jumpToBanner = document.querySelector(".location__jump-to-container");
            jumpToBanner.style.display = "block";
        // TODO: Clear LocalStorage / Cookie.
        // console.log('I am loading - geolocation.js - Fully Cancelled');
        };
        trigger.addEventListener("click", cancelGeoLocation);
    }
}


/**
 * Enable GeoLocation
 */ async function $959f3c2c431d9b50$export$2e2bcd8739ae039() {
    // console.log('I am loading - geolocation.js - Start');
    const stateName = getCookie("stateName");
    const stateCode = getCookie("stateCode");
    if (stateName && stateCode) {
        const state = {
            name: stateName,
            code: stateCode
        };
        updateUIWithStateInfo(state);
    // console.log('Getting information from cookie - ' + stateName + ', ' + stateCode);
    } else console.log("No state information found in cookies.");
    const cancelButton = document.querySelector(".geolocation-cancel");
    if (cancelButton) cancelButton.addEventListener("click", function() {
        // Delete cookies
        deleteCookie("stateName");
        deleteCookie("stateCode");
        // Show all divs
        showAllDivs();
    // console.log('Cookies cleared and all divs displayed.');
    });
    const locationTriggers = document.getElementsByClassName("geolocation-trigger");
    const triggerArray = Array.from(locationTriggers).entries();
    let $currentPath = document.location.pathname;
    let $approvedUris = [
        "/states"
    ];
    let mobileMoreButton = document.getElementById("location__banner--mobile-more");
    for (let [index, trigger] of triggerArray)trigger.addEventListener("click", async function() {
        if ($currentPath.indexOf($approvedUris) > -1) {
            // console.log('Triggering GeoLocation');
            geoLocationLoaderContent();
            navigator.geolocation.getCurrentPosition(async (position)=>{
                // console.log('Geolocation successful!', position);
                const user_latitude = position.coords.latitude;
                const user_longitude = position.coords.longitude;
                try {
                    const response = await getStateFromCoordinates(user_latitude, user_longitude); // Await the async call
                    // console.log('Response received:', response);
                    if (response.name) updateUIWithStateInfo(response);
                    else displayError("Location not within a US state");
                } catch (error) {
                    console.error("Failed to get state from coordinates:", error);
                    displayError("Failed to process geolocation data");
                }
            }, (error)=>{
                console.error("Geolocation failed:", error);
                displayError("Geolocation request failed");
            });
        }
    });
    function updateUIWithStateInfo(state) {
        const geoLocationElement = document.getElementById("geolocation-found");
        geoLocationElement.innerHTML = state.name; // Display the state name
        // Hide the 'location' and 'Jump To' banners, as they are not needed.
        const defaultLocationBanner = document.getElementsByClassName("location__banner--default");
        defaultLocationBanner[0].style.display = "none";
        const jumpToBanner = document.querySelector(".location__jump-to-container");
        jumpToBanner.style.display = "none";
        // Show the 'located' banner.
        const locatedBanner = document.getElementsByClassName("location__banner--located");
        locatedBanner[0].style.display = "flex";
        // TODO: Save location to LocalStorage / Cookie.
        // Close Modal altogether, once we have the data AND it has been populated.
        let modalTrigger = document.getElementsByClassName("modal-item open-modal");
        let triggerArray = Array.from(modalTrigger).entries();
        for (let [index, modalTriggerItem] of triggerArray)modalTriggerItem.classList.toggle("open-modal");
        updateStateVisibility(state.code);
        // Save cookie
        saveStateToCookie(state.name, state.code);
    }
    function displayError(message) {
        const locationFailedWrapper = document.getElementById("geolocation-failed");
        const locationFailed = document.querySelector("div.geolocation-failed__warning h3");
        const locationPending = document.getElementById("geolocation-pending");
        locationFailed.textContent = message; // Update error message
        locationFailedWrapper.style.display = "block";
        locationPending.style.display = "none";
    }
    function geoLocationLoaderContent() {
        const locationPending = document.getElementById("geolocation-pending");
        locationPending.style.display = "flex";
        const modalTrigger = document.getElementById("modal-geotrigger");
        modalTrigger.style.display = "none";
    }
    function getStateFromCoordinates(latitude, longitude) {
        const accessToken = "pk.eyJ1IjoibWFyaWFub2xhYiIsImEiOiJjbHYxMGZsOTgwMXZpMnJzMXZnYnJ4aWhhIn0.5xMzHrTnOuGAZhVWW_QMFQ";
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?types=region&access_token=${accessToken}`;
        return fetch(url) // Return the fetch promise
        .then((response)=>response.json()).then((data)=>{
            if (data.features && data.features.length) {
                const place = data.features.find((feature)=>feature.context.some((context)=>context.short_code === "us"));
                if (place) return {
                    name: place.text,
                    code: place.properties.short_code.toUpperCase().split("-")[1]
                };
                throw new Error("Location not within a US state");
            }
            throw new Error("No results found");
        });
    }
    function updateStateVisibility(stateCode) {
        // Hide all divs with classes 'state-accordion' y 'state-divider'
        const allDivs = document.querySelectorAll(".state-accordion, .state-divider");
        allDivs.forEach((div)=>{
            div.style.display = "none"; // Ocultar div
        });
        // Show only those divs whose attribute 'data-state' matches 'stateCode'
        const matchingDivs = document.querySelectorAll(`.state-divider[data-state="${stateCode}"], .state-accordion[data-state="${stateCode}"]`);
        matchingDivs.forEach((div)=>{
            div.style.display = "block";
        });
    }
    function showAllDivs() {
        const divs = document.querySelectorAll(".state-accordion, .state-divider");
        divs.forEach((div)=>{
            div.style.display = "block"; // Show all divs
        });
    }
    function setCookie(name, value, daysToExpire) {
        const date = new Date();
        date.setTime(date.getTime() + daysToExpire * 86400000); // Configurar la fecha de expiración
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    }
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(";");
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }
    function saveStateToCookie(stateName, stateCode) {
        setCookie("stateName", stateName, 7);
        setCookie("stateCode", stateCode, 7);
    }
    function deleteCookie(name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }
    if (null !== mobileMoreButton) mobileMoreButton.addEventListener("click", function() {
        if (document.getElementById("location__banner--located").classList.contains("mobile-show")) document.getElementById("location__banner--located").classList.remove("mobile-show");
        else document.getElementById("location__banner--located").classList.add("mobile-show");
    });
}


function $b5afd96e3b223a39$export$2e2bcd8739ae039() {
    // Hidden dropdown selector for 'GeoLocation Modal'.
    let dropdownSelector = jQuery("#modal-location");
    // Hidden dropdown selector for 'State Filter'.
    let stateSelector = jQuery("#filter-state-assn option:selected");
    // console.log(dropdownSelector);
    if (dropdownSelector) // console.log('Dropdown exists');
    dropdownSelector.on("change", function() {
        var newValue = jQuery(this).val();
        var newText = jQuery(this).text();
        // Update the hidden 'State Selector' dropdown, to trigger filtering.
        stateSelector.val(newValue).text(newText).change();
        // Update the visible text.
        jQuery("#filter-state-assn-selectized").val(newText);
        // Close Modal altogether, once we have the data AND it has been populated.
        let modalTrigger = document.getElementsByClassName("modal-item open-modal");
        let triggerArray = Array.from(modalTrigger).entries();
        for (let [index, modalTriggerItem] of triggerArray)modalTriggerItem.classList.toggle("open-modal");
    });
}


/**
 * Jump To Letters (State Page)
 */ function $f7d571df84ffaa3e$export$2e2bcd8739ae039() {
    //   console.log('I am loading - jump-to-letters.js - Start 4');
    const links = document.querySelectorAll(".jump-to__alphabet a"); // Select all links
    const navbarHeight = document.querySelector(".site-header").offsetHeight;
    const marginTop = 740;
    const backToTop = document.querySelector(".back-to-top");
    if (null !== links) links.forEach(function(link) {
        link.addEventListener("click", function(e) {
            e.preventDefault(); // Prevent the default link behavior
            const letterToJump = e.target.textContent.trim();
            // Find the first state that starts with that letter
            const targetElement = document.querySelector(`.state-divider[data-state^="${letterToJump}"]`);
            if (targetElement) window.scrollTo({
                top: targetElement.offsetTop + marginTop,
                behavior: "smooth" // Specify that the scroll should be smooth
            });
        });
    });
    // Animate the scroll at the begining of the page 
    if (null !== backToTop) {
        backToTop.addEventListener("click", function(e) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });
        // Smooth scroll
        window.onscroll = function() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) document.querySelector(".back-to-top").style.display = "block";
            else document.querySelector(".back-to-top").style.display = "none";
        };
    }
}


// jQuery(document).ready(function($) {
//   if ($('.filter-sidebar').length > 0) {
//     //   $('.filter-sidebar__taxonomy-title').click(function() {
//     //       $(this).toggleClass('active');
//     //       $('.taxonomy-' + $(this).attr('data-target')).slideToggle();
//     //   });
//     //   // Get params from URL and apply to filters
//     //   if (window.location.search != '') {
//     //       autoPopulateFiltersFromURL();
//     //   }
//       // Fetch initial posts
//       doFilter();
//       $('.btn-do-filter').on('click', function() {
//           $('#paged').val(1);
//           doFilter();
//       });
//       // Posts Search field
//     //   $('.search-field').on('keyup', function(e) {
//     //       if (e.keyCode === 13) {
//     //           doSearch();
//     //       }
//     //   });
//     //   $('.search-button').on('click', function() {
//     //       $('#paged').val(1);
//     //       doFilter();
//     //   })
//       mobileFilters();
//       // Remove filter
//     //   $(document).on('click', '.btn-remove-filter', function(){
//     //       var tax = $(this).attr('data-tax');
//     //       var term = $(this).attr('data-term');
//     //       $(this).remove();
//     //       $('.checkbox-terms[value='+term+']').parent('.input-checked').removeClass('input-checked')
//     //       $('.checkbox-terms[value='+term+']').attr('checked', false);
//     //       $('.checkbox-terms[value='+term+']').prop('checked', false);
//     //       doFilter();
//     //   });
//       // Pagination
//       /*$(document).on('click', '.results-container__pagination a.page-numbers', function(){
//           if (!jQuery(this).hasClass('disabled')) {
//               if (jQuery(this).text() > 0) {
//                   jQuery('#paged').val(jQuery(this).text());
//               } else if (jQuery(this).hasClass('prev')) {
//                   jQuery('#paged').val((jQuery('#paged').val()*1)-1);
//               } else if (jQuery(this).hasClass('next')) {
//                   jQuery('#paged').val((jQuery('#paged').val()*1)+1);
//               }
//           }
//           doFilter();
//       });*/
//       $('.button-load-more').click(function () {
//           var paged = parseInt($('#paged').val()) + 1;
//           $('#paged').val(paged);
//           // Load more Blog Resources
//           doFilter();
//       });
//       // Clear Filters
//       $(document).on('click','.button__clear-all' ,function () {
//           // Remove params from URL
//           removeURLParameters();
//           // Remove current content
//           // $('.archive-resources__content').empty();
//         //   $('.tags-filtered').empty();
//         //   clearFilterTerms();
//         //   $('.field-search-ajax').val('');
//           $('#paged').val(1);
//           // $(this).css('display', 'none');
//           // Reset resources results
//           doFilter();
//       });
//       // Styles for the checkbox
//     //   $('.terms li').on('click',function(){
//     //       if($(this).hasClass('input-checked')){
//     //           $(this).removeClass('input-checked')
//     //           $(this).find('.checkbox-terms').attr('checked', false).change();
//     //       }else{
//     //           $(this).addClass('input-checked')
//     //           $(this).find('.checkbox-terms').attr('checked', true).change();
//     //       }
//     //       // Count terms selected for that taxonomy
//     //       var count = 0;
//     //       var tax = $('input', this).attr('data-tax');
//     //       $('ul[data-tax="' + tax + '"] li input').each(function() {
//     //           if ($(this).is(':checked')) {
//     //               count++;
//     //           }
//     //       });
//     //       // Modify the count for that taxonomy
//     //       if (count > 0)
//     //           $('h4[data-target="' + tax + '"] .count').html( '(' + count + ')' );
//     //       else 
//     //           $('h4[data-target="' + tax + '"] .count').html( '' );
//     //   });
//       // Reveal filters on Mobile
//     //   $('.mobile-filter-group > h4').on('click',function(){
//     //       $('.filter-taxonomy-container').slideToggle('slow');
//     //   })
//       // Check for mobile to reveal filters 
//     //   var windowsize = $(window).width();
//     //   $(window).resize(function() {
//     //       windowsize = $(window).width();
//     //       if (windowsize >= 768) {
//     //           $('.filter-taxonomy-container').slideDown();
//     //       }
//     //   });
//       // Search button functionality
//       /*$('.search-ajax-button').on('click', function() {
//           if ($('.field-search-ajax').val() != '') {
//               // Do a smooth scroll to view results in case the results are not on the viewport
//               $('html, body').animate({
//                   scrollTop: $('.search-ajax-button').offset().top
//                 }, 800);
//               doFilter(); // Filter results based on search criteria
//           }
//       });*/
//       // Hiding blur when scroll is at the bottom of the listing
//     //   $('ul.terms').scroll(function() {
//     //       var div_height = 200;
//     //       if (($(this).scrollTop()) >= ($(this)[0].scrollHeight - div_height)) {
//     //           $(this).parent().addClass('remove-blur');
//     //       } else {
//     //           $(this).parent().removeClass('remove-blur');
//     //       }
//     //   });
//       // Filter terms while typing on the search input
//     //   $('.search-terms').keyup(function(e) {
//     //       var search_term = $(this).val();
//     //       $('input[data-tax=' + $(this).attr('data-tax-target')).each(function() {
//     //           var input_value = $(this).attr('data-name');
//     //           if (search_term == '' || input_value.toLowerCase().match(search_term)) {
//     //               $(this).parent().css('display', '');
//     //           } else {
//     //               $(this).parent().css('display', 'none');
//     //           }
//     //       });
//     //   });
//     //   $('.filters-sort').change(function() {
//     //       $('#paged').val('1');
//     //       doFilter();
//     //   });
//     //   $('.filters-event-type').change(function() {
//     //       $('#paged').val('1');
//     //       doFilter();
//     //   });
//       // Date Range
//     //   $('.radio-terms').change(function() {
//     //       if ($(this).val() == 'custom') {
//     //           $('.date-inputs').css('display', 'flex');
//     //       } else {
//     //           $('.date-inputs').css('display', 'none');
//     //           $('#filter-date-from').val('');
//     //           $('#filter-date-from').attr('type', 'text');
//     //           $('#filter-date-to').val('');
//     //           $('#filter-date-to').attr('type', 'text');
//     //       }
//     //   }); 
//     //   $('#filter-date-from').focus(function() {
//     //       $(this).attr('type', 'date');
//     //   });
//     //   $('#filter-date-from').blur(function() {
//     //       if ($(this).val() == '') 
//     //           $(this).attr('type', 'text');
//     //   });
//     //   $('#filter-date-to').focus(function() {
//     //       $(this).attr('type', 'date');
//     //   });
//     //   $('#filter-date-to').blur(function() {
//     //       if ($(this).val() == '') 
//     //           $(this).attr('type', 'text');
//     //   });
//   }
// });
function $27355be0d8d336c8$var$doFilter() {
    // Scroll to top to avoid staying at the bottom
    /*$('html, body').animate({
      scrollTop: $('.archive-resources__listing').offset().top
  }, 800);*/ // Hide pagination 
    //$('.results-container__pagination').html('');
    $("#load-more").css("display", "none");
    // Show loading
    $(".spinner").addClass("loading");
    // If we are pulling first page, remove all previous posts
    if ($("#paged").val() == 1) $(".results-container__posts").empty();
    // Check if we are hiding filters and filtering for a custom tax
    //   $('.tags-filtered').empty(); // Clear old filter terms
    //   var terms = getFilterTerms(); // Get Terms
    //   console.log(terms);
    //   console.log(Object.keys(terms).length);
    // Show clear all if there are filters
    if (Object.keys(terms).length > 0) $(".button__clear-all").css("display", "flex");
    else $(".button__clear-all").css("display", "none");
    var date_range = $27355be0d8d336c8$var$getDateRange();
    var orderby = $27355be0d8d336c8$var$getOrderBy();
    // Build URL Parameters
    //   buildURLParameters(terms, $('input[name=date-range]:checked').val(), date_range, orderby);
    // AJAX call
    $.ajax({
        url: ajax_var.url,
        method: "POST",
        data: {
            action: $("#action").val(),
            post_type: $("#post_type").val(),
            terms: terms,
            orderby: orderby,
            search: $(".field-search-ajax:visible").val(),
            events_type: $(".filters-event-type").val(),
            paged: $("#paged").val()
        },
        success: function(response) {
            if (response && response.success) {
                // Add new content
                if (response.data.count > 0) {
                    // Scroll To last post row if page is not the first one
                    if ($("#paged").val() != 1) $("html, body").animate({
                        scrollTop: $(".results-container__loader").offset().top
                    }, "slow");
                    if (response.data.count < response.data.posts_per_page) var results_found = "Showing " + response.data.count + " out of " + response.data.count + " results";
                    else var results_found = response.data.posts_per_page * $("#paged").val() + " out of " + response.data.count + " results showing";
                    $(".results-found-qty").html(results_found);
                    if ($("#post_type").val() == "events") $(".results-found-qty").html($(".filters-event-type").find(":selected").text());
                    else $(".results-found-qty").html(results_found);
                    $(".results-container__posts").append(response.data.html);
                } else {
                    $(".results-container__posts").html("No results found");
                    $(".results-found-qty").html("0 results showing");
                }
                // Hide loading
                $(".spinner").removeClass("loading");
                // Check if I need to show again the pagination
                //if (response.data.pagination) {
                if (response.data.see_more) $(".button-load-more").css("display", "flex");
            }
        },
        error: function(error) {
            console.log(error);
            // Hide loading
            $(".spinner").removeClass("loading");
        }
    });
    $(".filter-taxonomy-container .filter-sidebar__taxonomy").each(function() {
        var taxCount = 0;
        $(this).find(".input-checked").each(function() {
            taxCount = taxCount + 1;
        });
        if (taxCount > 0) $(this).find(".filter-sidebar__taxonomy-title .count").text("(" + taxCount + ")");
        else $(this).find(".filter-sidebar__taxonomy-title .count").text("");
    });
    var globalCount = $(".results-container .tags-filtered .tag-button").length;
    $(".mobile-filter-group .global-count").text("(" + globalCount + ")");
}
function $27355be0d8d336c8$var$getFilterTerms() {
    var terms1 = {};
    $("ul.terms").each(function() {
        $(".checkbox-terms", this).each(function() {
            if ($(this).is(":checked")) {
                if ($(this).attr("data-tax") in terms1 == false) terms1[$(this).attr("data-tax")] = [];
                terms1[$(this).attr("data-tax")][terms1[$(this).attr("data-tax")].length] = $(this).val();
                $(".tags-filtered").append('<a href="javascript: void(0)" data-tax="' + $(this).attr("data-tax") + '" data-term="' + $(this).val() + '" title="' + $(this).attr("data-name") + '" class="btn-remove-filter tag-button tag-button-' + $(this).attr("data-tax") + "-" + $(this).val() + '"><span class="button-text">' + $(this).attr("data-name") + '</span><img src="/wp-content/themes/hcls-wp/images/icon-close.svg"></a>');
            }
        });
    });
    return terms1;
}
function $27355be0d8d336c8$var$clearFilterTerms() {
    $(".checkbox-terms").each(function() {
        $(this).removeClass("checked").attr("checked", false);
    });
    $(".input-checked").removeClass("input-checked");
}
function $27355be0d8d336c8$var$doSearch() {
    $("#paged").val("1");
    $27355be0d8d336c8$var$doFilter();
}
function $27355be0d8d336c8$var$removeFilter(tax, term) {
    $(".tag-button-" + tax + "-" + term).remove();
    $(".checkbox-terms").each(function() {
        if ($(this).attr("data-tax") == tax && $(this).val() == term) $(this).prop("checked", false);
    });
    $27355be0d8d336c8$var$removeURLParameters();
    $27355be0d8d336c8$var$doFilter();
}
function $27355be0d8d336c8$var$getDateRange() {
    var dates_range = [
        "",
        ""
    ];
    if ($("#filter-date-from").val() != "" && $("#filter-date-from").val() != "") {
        dates_range[0] = $("#filter-date-from").val();
        dates_range[1] = $("#filter-date-to").val();
    }
    return dates_range;
}
function $27355be0d8d336c8$var$getOrderBy() {
    return $(".filters-sort").val();
}
function $27355be0d8d336c8$var$modifyPaginationLinks() {
    // Modify href of each pagination link to perform a JS call
    jQuery(".results-container__pagination a.page-numbers").each(function() {
        if (!jQuery(this).hasClass("disabled")) jQuery(this).attr("href", "javascript: void(0);");
    });
}
// Build the URL parameters as the users filters
function $27355be0d8d336c8$var$buildURLParameters(terms1, date_filter, date_range, order_by) {
    // Add filters used to URL as params. This is used to save filters on URL to allow sharing
    var current_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    var url_params = "";
    // Loop terms
    $.each(terms1, function(key, value) {
        url_params += url_params == "" ? "?" : "&";
        url_params += key + "_filter=" + value;
    });
    // Date range
    if (date_filter) {
        url_params += url_params == "" ? "?" : "&";
        url_params += "date_filter=" + date_filter;
        if (date_filter == "custom") url_params += "&date_from=" + date_range[0] + "&date_to=" + date_range[1];
    }
    // Order By
    if (order_by && url_params != "") {
        url_params += url_params == "" ? "?" : "&";
        url_params += "order_by=" + order_by;
    }
    current_url += url_params;
    window.history.pushState({
        path: current_url
    }, "", current_url);
}
function $27355be0d8d336c8$var$removeURLParameters() {
    var current_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.pushState({
        path: current_url
    }, "", current_url);
}
// Used on load page to get all URL parameters
function $27355be0d8d336c8$var$getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split("&"), sParameterName, i1;
    for(i1 = 0; i1 < sURLVariables.length; i1++){
        sParameterName = sURLVariables[i1].split("=");
        if (sParameterName[0] === sParam) return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
}
function $27355be0d8d336c8$var$autoPopulateFiltersFromURL() {
    $("ul.terms").each(function() {
        var params_str = $27355be0d8d336c8$var$getUrlParameter($(this).attr("data-tax") + "_filter");
        if (params_str) {
            var params_arr = params_str.split(",");
            for(i = 0; i < params_arr.length; i++)$("input[data-tax=" + $(this).attr("data-tax") + "]").each(function() {
                if ($(this).val() == params_arr[i]) {
                    $(this).prop("checked", true);
                    $(this).parent().addClass("input-checked");
                }
            });
        }
    });
    var date_filter = $27355be0d8d336c8$var$getUrlParameter("date_filter");
    if (date_filter) {
        $(".radio-terms[value=" + date_filter + "]").prop("checked", true);
        if (date_filter == "custom") {
            $(".date-inputs").css("display", "flex");
            $("#filter-date-from").val($27355be0d8d336c8$var$getUrlParameter("date_from"));
            $("#filter-date-from").attr("type", "date");
            $("#filter-date-to").val($27355be0d8d336c8$var$getUrlParameter("date_to"));
            $("#filter-date-to").attr("type", "date");
        }
    }
    // Check if there's a specific order by
    var order_by = $27355be0d8d336c8$var$getUrlParameter("order_by");
    if (order_by) $(".filters-sort").val(order_by);
/*$('html, body').animate({
      scrollTop: $('.search-ajax-button').offset().top
      }, 800);*/ }
function $27355be0d8d336c8$var$mobileFilters() {
    $(".mobileFilters").on("click", function() {
        $(".filter-sidebar").slideToggle();
        $(".archive-content__inner__summary .filter-sidebar__taxonomy").slideToggle();
    });
}


jQuery(document).ready(function($1) {
    if ($1(".podcast-archive__filter").length > 0) {
        // Add Spinner
        $1(".spinner").addClass("loading");
        $a9638ce8510dfbe0$var$doFilterPodcasts();
        $1("#filter-season").change(function() {
            // If we are pulling first page, remove all previous posts
            $1(".results-container__posts").empty();
            // Set page to 1 as we are new-filtering.
            $1("#paged").val("1");
            $a9638ce8510dfbe0$var$doFilterPodcasts();
        });
        // Add control for "Clear All".
        $1(".podcast-archive__filter-clear").click(function() {
            var paged = 1;
            $1("#paged").val(paged);
            // Set all seasons as default when Clearing
            var selectize = $1("#filter-season")[0].selectize;
            selectize.setValue("all"); // This triggers the reload of the page
        // Re-load Podcast Resources
        //doFilterPodcasts();
        });
        $1(".podcast-archive__load-more").click(function() {
            var paged = parseInt($1("#paged").val()) + 1;
            $1("#paged").val(paged);
            // Load more Podcast Resources
            $a9638ce8510dfbe0$var$doFilterPodcasts();
        });
    }
});
function $a9638ce8510dfbe0$var$doFilterPodcasts() {
    // Hide pagination 
    $(".podcast-archive__load-more").css("display", "none");
    // Show loading
    $(".spinner").addClass("loading");
    // If we are pulling first page, remove all previous posts
    if ($("#paged").val() == 1) $(".results-container__posts").empty();
    // Build URL Parameters
    // buildURLParameters(terms, $('input[name=date-range]:checked').val(), date_range, orderby);
    var season = $a9638ce8510dfbe0$var$getFilterSeason();
    // AJAX call
    $.ajax({
        url: ajax_var.url,
        nonce: ajax_var.nonce,
        method: "POST",
        data: {
            action: "taoti_archive_query_more",
            post_type: "podcasts",
            season: season,
            paged: $("#paged").val()
        },
        success: function(response) {
            if (response && response.success) {
                // Add new content
                if (response.data.count > 0) // Scroll To last post row if page is not the first one
                // if ($('#paged').val() != 1) {
                //     $('html, body').animate({scrollTop: $('.results-container__loader').offset().top}, 'slow');
                // }
                $(".results-container__posts").append(response.data.html);
                else {
                    $(".results-container__posts").html("No results found");
                    $(".results-found-qty").html("0 results showing");
                }
                // Hide loading
                $(".spinner").removeClass("loading");
                // Check if I need to show again the pagination
                if (response.data.see_more) {
                    $(".podcast-archive__load-more-wrapper").css("display", "flex");
                    $(".podcast-archive__load-more").css("display", "flex");
                }
            }
        },
        error: function(error) {
            console.log(error);
            // Hide loading
            $(".spinner").removeClass("loading");
        }
    });
}
function $a9638ce8510dfbe0$var$getFilterSeason() {
    // Term 'slug'.
    let season = $("#filter-season").find(":selected").val();
    return season;
}


jQuery(document).ready(function($) {
    let $wrapper = $(".podcast__transcript--wrapper"); // Select the transcript wrapper element
    let scrollHeight = $wrapper.length > 0 ? $wrapper.get(0).scrollHeight : 0; // Get the scroll height of the wrapper if it exists
    let offsetHeight = $wrapper.length > 0 ? $wrapper.get(0).offsetHeight : 0; // Get the offset height of the wrapper if it exists
    let $loadMore = $(".podcast__transcript--more"); // Select the 'Load More' button
    // console.log('scrollHeight: ' + scrollHeight);
    // console.log('OffsetHeight: ' + offsetHeight);
    /* Show 'Load More' button if content hidden. */ if (offsetHeight + 1 < scrollHeight) $loadMore.css("display", "flex");
    /* Show all content when 'Load More' clicked. */ if ($loadMore.length > 0) $loadMore.find(".button").on("click", function(ev) {
        ev.preventDefault();
        if (offsetHeight <= scrollHeight) {
            $wrapper.css("max-height", "100%");
            $wrapper.css("overflow", "visible");
            $(this).remove();
        }
    });
});


// Easy console access to jQuery through '$'
window.$ = jQuery;
// Add the 'State Content Filter' to the 'Window' for use by the <input> field.
if (null !== (0, $b2a8c2caad66ecf5$export$f838c8bfb28edc63)) window.stateContentFilter = (0, $b2a8c2caad66ecf5$export$f838c8bfb28edc63);
// Theme JS.
jQuery(document).ready(function($) {
    (0, $7ea0b8b073c2add7$export$2e2bcd8739ae039)();
    // console.log('I AM LOADING - Main.js');
    (0, $a0b9ba5cc79899f3$export$2e2bcd8739ae039)();
    (0, $959f3c2c431d9b50$export$2e2bcd8739ae039)();
    (0, $46dfd3e75536697e$export$2e2bcd8739ae039)();
    (0, $f7d571df84ffaa3e$export$2e2bcd8739ae039)();
    (0, $b5afd96e3b223a39$export$2e2bcd8739ae039)();
});

})();
//# sourceMappingURL=main.js.map
